import RecoverAccountForm from './RecoverAccountForm';

export default RecoverAccountForm;


// WEBPACK FOOTER //
// ./src/components/forms/RecoverAccountForm/index.js